/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENTS_TAB = "ALL_COMMENTS" | "FEATURED_COMMENTS" | "NONE" | "QUESTIONS" | "REVIEWS" | "UNANSWERED_COMMENTS" | "%future added value";
export type COMMENT_SORT = "CREATED_AT_ASC" | "CREATED_AT_DESC" | "REACTION_DESC" | "REPLIES_DESC" | "%future added value";
export type FeaturedCommentsContainerLocal = {
    readonly commentsOrderBy: COMMENT_SORT;
    readonly commentsTab: COMMENTS_TAB;
    readonly " $refType": "FeaturedCommentsContainerLocal";
};
export type FeaturedCommentsContainerLocal$data = FeaturedCommentsContainerLocal;
export type FeaturedCommentsContainerLocal$key = {
    readonly " $data"?: FeaturedCommentsContainerLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"FeaturedCommentsContainerLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "FeaturedCommentsContainerLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commentsOrderBy",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commentsTab",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = 'fd36a6f432a2da9faea44fdf7eb5305b';
export default node;
